export default __webpack_public_path__ + "scale.da34b7ae.png";